import { ImportLoadingDialog, LoadingDialog } from "@/components/Dialogs/LoadingDialog"
import { MetadataProgressDialog } from "@/components/Dialogs/MetadataProgressDialog"
import { StylePublishLoadingDialog } from "@/components/Dialogs/StylePublishLoadingDialog"
import { dialogsAtom, popDialog } from "@/store/dialogs-state"
import { store } from "@/store/store"

const isLoadingDialog = (dialog?: unknown) =>
	dialog === LoadingDialog ||
	dialog === ImportLoadingDialog ||
	dialog === MetadataProgressDialog ||
	dialog === StylePublishLoadingDialog

export const popActiveLoadingDialogs = () => {
	while (isLoadingDialog(store.get(dialogsAtom).at(-1)?.[0])) {
		popDialog()
	}
}
